import React, {Fragment} from 'react';
import ReactToggle from 'react-toggle';

import './Toggle.scss';

export default (field) => {
  const icons = (field.icons || field.icons === false) ? field.icons :true
  return (
    <Fragment>
      <label className="d-flex justify-content-between align-items-center my-1" style={{gap: '4px'}}>
        <span className={field.input.value ? 'toggle-label toggle-label' : 'toggle-label-active'}>{field.firstLabel}</span>
        <ReactToggle
          icons={icons}
          checked={!!field.input.value}
          onChange={field.input.onChange}
          disabled={!!field.disabled}
        />
        <span className={field.input.value ? 'toggle-label toggle-label-active': 'toggle-label'}>
          {field.secondLabel}
        </span>
      </label>
    </Fragment>
  );
};